module.exports = __webpack_public_path__ + "static/media/use_sanitizer.d8c454ef.png";